import { SupportButton } from 'components/atoms/SupportButton/SupportButton.js'
import { LinkedInNotLogged } from 'components/molecules/linkedInNotLogged/LinkedInNotLogged.js'
import { CONSTS } from 'config/objectConst.js'
import { LinkedInReauthProvider } from 'features/linkedin-login/LinkedInReauthProvider'
import { Outlet } from 'react-router-dom'
import { useDocumentTitle } from 'shared/hooks'

import { LeftSideMenu } from '../../molecules/leftSideMenu'
import { Header } from '../../organisms/Header/index'
import css from './HomeTemplate.module.scss'

export function LoggedLayout() {
	useDocumentTitle(CONSTS.PROJECT_NAME)
	return (
		<LinkedInReauthProvider>
			<div className={css.root}>
				<Header className={css.header} />
				<LeftSideMenu className={css.side} />
				<Outlet />

				<LinkedInNotLogged />
				<SupportButton />
			</div>
		</LinkedInReauthProvider>
	)
}
